import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FcLocationsInputModule } from '@core/components/fc-input/search-many/fc-locations-input/fc-locations-input.module';
import { FcRequestersInputModule } from '@core/components/fc-input/search-many/fc-requesters-input/fc-requesters-input.module';
import { CompanyLegacyModule } from '@core/components/legacy-input/search-one/company/company.module';
import { EquipmentLegacyModule } from '@core/components/legacy-input/search-one/equipment/equipment.module';
import { LocationLegacyModule } from '@core/components/legacy-input/search-one/location/location.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FcCompaniesInputModule } from '../../../core/components/fc-input/search-many/fc-companies-input/fc-companies-input.module';
import { FcPendencyTypesInputModule } from '../../../core/components/fc-input/search-many/fc-pendency-types-input/fc-pendency-types-input.module';
import { FcSegmentsInputModule } from '../../../core/components/fc-input/search-many/fc-segments-input/fc-segments-input.module';
import { SegmentsModule } from '../../../core/components/inputs/segments/segments.module';
import { StarsModule } from '../dialogs/dialog-edit-maintenance/tabs/logs/stars/stars.module';
import { FilterMaintenanceComponent } from './filter-maintenances.component';
import { MaintenanceFilterApi } from './services/maintenance-filter-api.service';
import { MaintenanceFilterState } from './services/maintenance-filter-state.service';

@NgModule({
  declarations: [
    FilterMaintenanceComponent
  ],
  imports: [
    FuseSharedModule,
    TranslateModule,
    MatDividerModule,
    MatListModule,
    MatSlideToggleModule,
    MatIconModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
    MatToolbarModule,
    MatTooltipModule,
    SegmentsModule,
    LocationLegacyModule,
    CompanyLegacyModule,
    StarsModule,
    EquipmentLegacyModule,
    FcLocationsInputModule,
    FcSegmentsInputModule,
    FcCompaniesInputModule,
    FcPendencyTypesInputModule,
    FcRequestersInputModule
],
  exports: [
    FilterMaintenanceComponent
  ],
  providers: [
    MaintenanceFilterState,
    MaintenanceFilterApi,
  ]
})
export class FilterMaintenanceModule { }
